module.exports = __webpack_public_path__ + "img/enterQuest.f3ef5b3e.gif";